import { render, staticRenderFns } from "./WcagModal.vue?vue&type=template&id=cc03a24e&"
import script from "./WcagModal.vue?vue&type=script&lang=js&"
export * from "./WcagModal.vue?vue&type=script&lang=js&"
import style0 from "./WcagModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports